import React, { useState, useRef, useEffect } from 'react'

import Field from '../../Field/Field'
import TextInput from '../../TextInput/TextInput'
import Textarea from '../../Textarea/Textarea'
import Tooltip from '../../Tooltip/Tooltip'
import FieldLabel from '../../FieldLabel/FieldLabel'
import Checkbox from '../../Checkbox/Checkbox'
import Help from '../../Help/Help'
import { fieldUidRegex, getContentTypeFieldDataTestId, CONTENT_TYPE_FIELD_ACTION_IDS, NonLocalizableDom, handleToggleClick, handleMarkParentNonLocalizable } from '../helper'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import { booleanTestIdFormatter } from './../../../utils/helpers'
import CustomUserLimit from './CustomUserLimit'
import MandatoryToggleSwitch from './MandatoryToggleSwitch'

export const Group = (props: any) => {
  const { onChange, options, parentInfo, uniqueKey, schema, type, isNonLocalizable, hasNonLocalizablePlan, hasUserCustomFieldLimit, hasNonLocalizablePlanForBlocksAndGroupMultiple, hasNonLocFieldsWithinGroupOrGlobalField } = props
  const [initialSchema, setSchema] = useState(schema)
  const { display_name, uid, field_metadata } = schema

  const displayNameRef: any = useRef(null)
  const [error, setError] = useState(fieldUidRegex(schema.uid, schema))

  useEffect(() => {
    displayNameRef?.current?.focus();
  }, [displayNameRef])

  const onchange = () => {
    onChange && onChange(schema)
    setSchema({ ...schema })
  }
  const onDisplayNameChange = (event: any) => {
    schema.display_name = event.target.value

    if (schema.hasOwnProperty('display_name') && schema.newfield) {
      schema.uid = schema.display_name
        .trim()
        .replace(/[^A-Z0-9]+/gi, '_')
        .toLowerCase()
      if (schema.display_name) {
        schema.error_details = {
          ...schema.error_details,
          uid: ''
        }
      }
    }

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.display_name.length) {
      schema.error_details = {
        ...schema.error_details,
        display_name: 'Display Name cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        display_name: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onUidChange = (event: any) => {
    setError(fieldUidRegex(event.target?.value?.trim(), schema))

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.uid.length) {
      schema.error_details = {
        ...schema.error_details,
        uid: 'uid cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        uid: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onInstructionChange = (event: any) => {
    field_metadata.instruction = event.target.value
    onchange()
  }
  const onHelpTextChange = (event: any) => {
    field_metadata.description = event.target.value
    onchange()
  }
  const onOptionsChange = (event: any) => {
    if (event.target.name === `${uniqueKey}.mandatory`) {
      schema.mandatory = event.target.checked
    }
    if (event.target.name === `${uniqueKey}.multiple`) {
      if (hasNonLocalizablePlanForBlocksAndGroupMultiple) {
        if (event.target.checked) {
          handleToggleClick(event, schema.data_type, schema, onchange, 'multiple', props.t , parentInfo.isInsideMultiple ,parentInfo.ancestorWithMultipleType);
        } else {
          schema.multiple = event.target.checked;
          // updateChildrenSChema(schema, false);
        }
      } else {
        schema.multiple = event.target.checked;
      }
      if (!schema.multiple) {
        Array.isArray(schema?.schema) && schema.schema.forEach((field) => {
          if (field.data_type !== 'group' && field?.field_metadata?.isTitle) field.field_metadata.isTitle = false
        })
        Array.isArray(schema?.children) && schema.children.forEach((field) => {
          if (field.data_type !== 'group' && field?.field_metadata?.isTitle) field.field_metadata.isTitle = false
        })
      }
      schema.error_details = {
        ...schema.error_details,
        max_instance: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
      if (!schema.multiple) {
        if (schema.hasOwnProperty('max_instance')) {
          delete schema.max_instance
        }
        if (schema.hasOwnProperty('min_instance')) {
          delete schema.min_instance
        }
      }
    }
    if (event.target.name === `${uniqueKey}.nonLocalization`) {
      if(event.target.checked && hasNonLocalizablePlanForBlocksAndGroupMultiple && !parentInfo?.isInsideMultiple){
          handleMarkParentNonLocalizable(schema, onchange)
      }
      else if (event.target.checked && parentInfo.hasParent && hasNonLocalizablePlanForBlocksAndGroupMultiple) {
        handleToggleClick(event, parentInfo.data_type, schema, onchange, 'nonLocalizable', props.t , parentInfo.isInsideMultiple ,parentInfo.ancestorWithMultipleType)
      }
      else {
        schema.non_localizable = event.target.checked
      }
    }
    onchange()
  }
  const onMaxInstance = (event: any) => {
    schema.max_instance = event.target.value ? parseInt(event.target.value) : null
    onchange()
  }

  if (type === 'basic') {
    return (
      <div className="FormFields">
        <Field>
          <FieldLabel className='FieldLabel__CT' version='v2' required htmlFor="displayName">
            Display Name
          </FieldLabel>
          <TextInput
            version='v2'
            required
            name={`${uniqueKey}.displayName`}
            value={display_name}
            onChange={onDisplayNameChange}
            inputRef={displayNameRef}
            error={schema.error && schema.error_details.display_name ? true : false}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}
          />
        </Field>

        <Field>
          <FieldLabel className='FieldLabel__CT' version='v2' required htmlFor="uid">
            Unique ID
          </FieldLabel>
          <Help type="basic" text="A unique ID for this field. This should not be same as the ID of any other field in this content type." />
          <TextInput
            version='v2'
            required
            name={`${uniqueKey}.uid`}
            value={uid}
            onChange={onUidChange}
            error={(schema.error && schema.error_details.uid) || error ? true : false}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}
          />
        </Field>

        <Field>
          <FieldLabel className='FieldLabel__CT' version='v2' htmlFor="instruction">Instruction Value</FieldLabel>
          <Help type="basic" text="Helps you add instructions for this field. The instructional text will appear below the field." />
          <Textarea
            version='v2'
            name={`${uniqueKey}.instruction`}
            value={field_metadata.instruction || ''}
            onChange={onInstructionChange}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            // multiline={true}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
            id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
          />
        </Field>

        <Field>
          <FieldLabel className='FieldLabel__CT' version='v2' htmlFor="helpText">Help Text</FieldLabel>
          <Help type="basic" text="Provide additional info about the field. The help text will appear when the user hovers on the ‘?’ sign beside the field name." />
          <Textarea
            version='v2'
            name={`${uniqueKey}.helpText`}
            value={field_metadata.description || ''}
            onChange={onHelpTextChange}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            // multiline={true}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
            id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
          />
        </Field>



      </div>
    )
  } else if (type === 'advanced') {
    return (
      <div className="FormFields">
        <Field>
          <FieldLabel className='FieldLabel__CT' version="v2" htmlFor="options">Other Options</FieldLabel>
          {hasUserCustomFieldLimit && (
            <MandatoryToggleSwitch
              uniqueKey={uniqueKey}
              schema={schema}
              onChange={onOptionsChange}
            />
          )}
          <div className={`ToggleWrap ${hasUserCustomFieldLimit ? 'flex-v-center mb-0' : ''}`}>
            <ToggleSwitch
              testId={booleanTestIdFormatter("cs-ct-field-group-multiple", schema.multiple)}
              name={`${uniqueKey}.multiple`}
              label="Multiple"
              checked={schema.multiple}
              onClick={onOptionsChange}
            />
            {hasUserCustomFieldLimit &&
              <div>
                <Help type="basic" className='mb-0 ml-8' iconName='Information' text={props.t('content_type.save_content_type.body.fields.tooltip_text.multiple') || "If enabled, you can define the minimum and maximum instances allowed for the field"} />
              </div>
            }
          </div>
          {schema.multiple ? (
            hasUserCustomFieldLimit ?
              <CustomUserLimit
                uniqueKey={uniqueKey}
                schema={schema}
                onchange={onchange}
                t={props.t}
                type={type}
              /> :
              <div className='ToggleWrap__sub_Field' >
                <Field>
                  <FieldLabel className='FieldLabel__CT' version="v2" htmlFor="validation">
                    Set Maximum Limit
                  </FieldLabel>
                  <TextInput
                    version="v2"
                    type="number"
                    name={`${uniqueKey}.maxinstance`}
                    value={schema.max_instance || null}
                    onChange={onMaxInstance}
                    // placeholder="Maximum"
                    placeholder={props.t(
                      'content_type.save_content_type.body.fields.common_properties.placeholders.maximum'
                    )}
                    error={schema.error && schema.max_instance ? true : false}
                    testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SET_MAX_LIMIT_INPUT)}
                  />
                </Field>
              </div>
          ) : null}
          {
            hasNonLocalizablePlan ? (
              hasNonLocalizablePlanForBlocksAndGroupMultiple ? (
                <NonLocalizableDom
                  isFieldPresent={true}
                  uniqueKey={uniqueKey}
                  schema={schema}
                  onOptionsChange={onOptionsChange}
                  dataTestId={booleanTestIdFormatter(schema.nonLocParams?.insideMultiple ? `cs-ct-field-group-non-localizable-parent-multiple` : `cs-ct-field-group-non-localizable`, schema.non_localizable)}
                  dataTestIdForDescription={"cs-ct-field-group-non-localizable-description"}
                  isNonLocalizable={isNonLocalizable}
                  hasUserCustomFieldLimit={hasUserCustomFieldLimit}
                  isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                />
              ) : (parentInfo.hasParent ? !parentInfo.isInsideMultiple : true) ?
                <NonLocalizableDom
                  isFieldPresent={true}
                  uniqueKey={uniqueKey}
                  schema={schema}
                  onOptionsChange={onOptionsChange}
                  dataTestId={booleanTestIdFormatter("cs-ct-field-group-non-localizable", schema.non_localizable)}
                  dataTestIdForDescription={"cs-ct-field-group-non-localizable-description"}
                  isNonLocalizable={isNonLocalizable}
                  hasUserCustomFieldLimit={hasUserCustomFieldLimit}
                  isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                />
                : null
            ) : null
          }
        </Field>
      </div>
    )
  }
}

export default React.memo(Group)
